import React from "react"
import { useAppSelector } from "../../hooks"

import "../resourcefooter/components/Footer.scss"
import StickyFooter from "./StickyFooter"

export default function Footer(): JSX.Element {
    const { buttons, isLoading } = useAppSelector((state) => state.stickyFooter)
    return (
        <StickyFooter
            buttons={buttons}
            isLoading={isLoading}
            footerClass="tw-px-4 tw-py-2 bg-white"
        />
    )
}
